// Client side checks of landing archives, mirrors SatelliteLandingService on the backend. The backend validates again
// (it detects the format by signature and checks the contents of the archive).

export const MAX_LANDING_ARCHIVE_SIZE = 8 * 1024 * 1024;

export const LANDING_ARCHIVE_EXTENSIONS = [".zip", ".tar", ".tar.gz", ".tgz"];

// Value of the accept attribute of the file input.
export const LANDING_ARCHIVE_ACCEPT = LANDING_ARCHIVE_EXTENSIONS.join(",");

export const LANDING_NAME_MAX_LENGTH = 255;

function archiveExtension(filename) {
  const lower = String(filename || "").toLowerCase();
  // ".tar.gz" goes before ".tar" and ".gz" would not match at all
  return [...LANDING_ARCHIVE_EXTENSIONS].sort((a, b) => b.length - a.length).find((extension) => lower.endsWith(extension)) || null;
}

// Returns [translation key, params] of the first error, or null if the file can be uploaded.
export function validateLandingArchive(file) {
  if (!file) return ["satellites.landings.errors.no_file"];
  if (!archiveExtension(file.name)) {
    return ["satellites.landings.errors.extension", { extensions: LANDING_ARCHIVE_EXTENSIONS.join(", ") }];
  }
  if (file.size > MAX_LANDING_ARCHIVE_SIZE) {
    return ["satellites.landings.errors.size", { size: formatBytes(MAX_LANDING_ARCHIVE_SIZE) }];
  }
  if (file.size === 0) return ["satellites.landings.errors.empty"];
  return null;
}

// Name the backend gives a landing uploaded without a name: the file name without the archive extension.
export function landingNameFromFile(filename) {
  const extension = archiveExtension(filename);
  const name = extension ? filename.slice(0, -extension.length) : String(filename || "");
  return name.slice(0, LANDING_NAME_MAX_LENGTH);
}

export function formatBytes(bytes) {
  const value = Number(bytes) || 0;
  if (value < 1024) return `${value} B`;
  const units = ["KB", "MB", "GB"];
  let size = value / 1024;
  let unit = 0;
  while (size >= 1024 && unit < units.length - 1) {
    size /= 1024;
    unit++;
  }
  return `${size >= 10 ? Math.round(size) : Math.round(size * 10) / 10} ${units[unit]}`;
}
